import {
  RECEIVE_GRANTS,
  RECEIVE_MEMBER_TYPES,
  REQUEST_MEMBERS,
  RECEIVE_MEMBERS,
  RECEIVE_TENANT_USERS,
  CREATE_MEMBER_SUCCESS,
  RECEIVE_INVITATIONS,
  DELETE_INVITATION_SUCCESS,
  CHECKED_INVITATIONS,
  REQUEST_SERVICE_ACCOUNTS,
  RECEIVE_SERVICE_ACCOUNTS,
  TRANSFER_SERVICE_ACCOUNTS,
  SET_CURRENT_USER,
} from './actions';
import { CLEAR_SITE_DATA } from '../application';

const initialState = {
  grants: undefined,
  currentUser: null,
  loadingMembers: true,
  loadingTenantUsers: true,
  loadingInvitations: true,
  loadingServiceAccounts: true,
  transferringServiceAccounts: false,
  checkedInvitations: null,
  members: [],
  memberTypes: [],
  tenantUsers: {},
  invitations: [],
  serviceAccounts: [],
};

export function reducer(state = structuredClone(initialState), action) {
  switch (action.type) {
    case RECEIVE_GRANTS: {
      return { ...state, grants: action.grants };
    }
    case RECEIVE_MEMBER_TYPES: {
      return { ...state, memberTypes: action.memberTypes };
    }
    case REQUEST_MEMBERS: {
      return {
        ...state,
        loadingMembers: true,
        loadingTenantUsers: !!action.indexUsers,
      };
    }
    case CREATE_MEMBER_SUCCESS:
    case RECEIVE_MEMBERS: {
      return {
        ...state,
        members: action.members,
        loadingMembers: false,
      };
    }
    case RECEIVE_TENANT_USERS: {
      return {
        ...state,
        tenantUsers: action.tenantUsers,
        loadingTenantUsers: false,
      };
    }
    case RECEIVE_INVITATIONS: {
      return {
        ...state,
        invitations: action.invitations,
        loadingInvitations: false,
      };
    }
    case DELETE_INVITATION_SUCCESS: {
      const inviteIndex = state.invitations.findIndex((index) => index.id === action.invitationId);
      return {
        ...state,
        invitations: [
          ...state.invitations.slice(0, inviteIndex),
          ...state.invitations.slice(inviteIndex + 1),
        ],
      };
    }

    case CHECKED_INVITATIONS: {
      return {
        ...state,
        checkedInvitations: action.checkedInvitations,
      };
    }

    case REQUEST_SERVICE_ACCOUNTS: {
      return {
        ...state,
        loadingServiceAccounts: true,
      };
    }

    case TRANSFER_SERVICE_ACCOUNTS: {
      return {
        ...state,
        transferringServiceAccounts: true,
      };
    }

    case RECEIVE_SERVICE_ACCOUNTS: {
      return {
        ...state,
        serviceAccounts: action.serviceAccounts,
        loadingServiceAccounts: false,
        transferringServiceAccounts: false,
      };
    }

    case SET_CURRENT_USER: {
      return {
        ...state,
        currentUser: { email: action.email, subject: action.subject },
      };
    }

    case CLEAR_SITE_DATA: {
      return {
        ...structuredClone(initialState),
        // Kept across the reset.
        grants: state.grants,
        currentUser: state.currentUser,
      };
    }
    default: {
      return state;
    }
  }
}
